<template>
    <Container>
        <SectionTitle>{{ $t('Contact.title') }}</SectionTitle>
        <div class="tw-mt-3 tw-flex tw-flex-col tw-gap-4 tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-p-4">
            <p class="tw-text-sm tw-text-dark sm:tw-text-base">
                {{ $t('Contact.description') }}
            </p>

            <div>
                <p class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-gray-500">
                    {{ $t('Contact.emailLabel') }}
                </p>
                <a
                    class="tw-mt-1 tw-inline-block tw-text-sm tw-text-primary tw-underline sm:tw-text-base"
                    :href="`mailto:${contactEmail}`">
                    {{ contactEmail }}
                </a>
            </div>

            <div>
                <p class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-gray-500">
                    {{ $t('Contact.addressLabel') }}
                </p>
                <p class="tw-mt-1 tw-text-sm tw-text-dark sm:tw-text-base">
                    {{ contactAddress }}
                </p>
            </div>
        </div>

        <SectionWrapper>
            <SettingButton
                :href="contactUrl"
                :icon="PhoneIcon"
                target="_blank">
                {{ $t('Contact.website') }}
            </SettingButton>
        </SectionWrapper>
    </Container>
</template>

<script setup lang="ts">
    import PhoneIcon from '@/components/icons/Phone.vue';
    import Container from '@/components/shared/Container.vue';
    import SectionTitle from '@/components/more/SectionTitle.vue';
    import SectionWrapper from '@/components/more/SectionWrapper.vue';
    import SettingButton from '@/components/more/SettingButton.vue';
    import { APP_CONTACT_ADDRESS, APP_CONTACT_EMAIL, APP_CONTACT_URL } from '@/configs/app';

    const contactEmail = APP_CONTACT_EMAIL;
    const contactAddress = APP_CONTACT_ADDRESS;
    const contactUrl = APP_CONTACT_URL;
</script>

<style scoped></style>
